var map = {
	"./ramen1.webp": 1676,
	"./ramen10.webp": 6604,
	"./ramen11.webp": 7577,
	"./ramen12.webp": 8729,
	"./ramen13.webp": 3772,
	"./ramen14.webp": 2600,
	"./ramen15.jpg": 968,
	"./ramen16.jpg": 5990,
	"./ramen17.webp": 5652,
	"./ramen18.webp": 4209,
	"./ramen19.jpg": 8650,
	"./ramen2.webp": 3960,
	"./ramen20.jpg": 9959,
	"./ramen21.png": 6802,
	"./ramen22.webp": 9357,
	"./ramen23.jpg": 5674,
	"./ramen24.webp": 814,
	"./ramen3.jpg": 1416,
	"./ramen4.png": 1982,
	"./ramen5.jpg": 1158,
	"./ramen6.webp": 653,
	"./ramen7.jpg": 6553,
	"./ramen8.jpg": 4427,
	"./ramen9.webp": 3970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4358;